var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-grow-1 align-center"},[_c('v-img',{attrs:{"src":require('@/assets/icons/ic-arrow-right.svg'),"contain":"","height":"16","sizes":"16","width":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }